import cacheableResources from './cacheable-resources';

import { sleep } from 'utilities';

class ResourcesCacher {

  constructor() {

    this.cached = 0;
    this.total = cacheableResources.length;

  }

  async start() {

    const resources = cacheableResources;

    for (let resource of resources) {

      await import( /* @vite-ignore */ resource.url);

      this.cached++;

      await sleep(100);

    }

  }

}

export default ResourcesCacher;